import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PROJROLE_ADMIN, PROJROLE_MEMBER, PROJROLE_READER } from '../../shared/constants';

@connect()
export default class RoleDropdown extends Component {
  static propTypes = {
    input: PropTypes.object.isRequired,
    userId: PropTypes.string,
    formObjectId: PropTypes.string,
    dispatch: PropTypes.func,
    changeUserRoleCallback: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const {
      formObjectId,
      userId,
      input: {
        onChange,
      },
      changeUserRoleCallback,
    } = this.props;

    const roleId = e.target.value;
    changeUserRoleCallback(formObjectId, userId, roleId);
    onChange(e);
  }

  render() {
    const {
      input: {
        ...inputProps,
      },
    } = this.props;
    // console.log('inputProps', inputProps);
    return (
      <select className="form-control c-select" {...inputProps} onChange={this.handleChange}>
        <option value={PROJROLE_ADMIN}>Admin</option>
        <option value={PROJROLE_MEMBER}>Member</option>
        <option value={PROJROLE_READER}>Reader</option>
      </select>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/form/RoleDropdown.js